const basePrice = 2000
const maxExtraPrice = 2000
export const maxSeats = 12
export const timeSlots = 48


export const calculatePrice = (flexibility, lowestSeats, highestSeats) => {

  //Price should never be below base cost

  //Best discount should be when filling a plane?
  // if (lowestSeats === 0) {
  //   return basePrice * ticketCount
  // }

  //If no full plane, give proportional discount
  //High flexibility -> higher discount
  const flexFactor = 1 - flexibility / (timeSlots+1)

  //More full plane -> higher discount
  const minSeatFactor = lowestSeats / maxSeats
  const maxSeatFactor = highestSeats / maxSeats

  const minExtra = flexFactor*minSeatFactor * maxExtraPrice
  const maxExtra = flexFactor*maxSeatFactor * maxExtraPrice

  const priceFrom = (basePrice + minExtra) |0
  const priceTo = (basePrice + maxExtra) |0
  //const result = pricePerSeat// * ticketCount

  const flexReduction = Math.floor(maxExtraPrice - flexFactor*maxExtraPrice)
  const minSeatReduction = Math.floor(maxExtraPrice - minSeatFactor * maxExtraPrice)

  //console.log({flexibility,lowestSeats,flexFactor,seatFactor,extraPrice,result, pricePerSeat})
  console.log({priceFrom,priceTo,minExtra,maxExtra})
  return {priceFrom,priceTo,flexReduction,minSeatReduction}
}